import { connect } from 'react-redux';
import { get } from 'lodash';
import React from 'react';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { getUserTimezone } from '@commons/utils/date';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { renderTimeViewClock, TimePicker as MuiTimePicker } from '@mui/x-date-pickers-pro';

import { Container } from './styledComponents';
import { USER_LANGUAGE_CODE } from '@commons/constants/country';

const TimePicker = (props) => {
  const { user, value, placeholder, disabled, onChange, customStyle } = props;

  const userLanguageCode = get(user, 'lnkLanguageAccountrel.code', 'fr');

  return (
    <LocalizationProvider adapterLocale={userLanguageCode} dateAdapter={AdapterMoment}>
      <Container style={customStyle}>
        <MuiTimePicker
          ampm={userLanguageCode === USER_LANGUAGE_CODE.EN}
          ampmInClock={userLanguageCode === USER_LANGUAGE_CODE.EN}
          closeOnSelect={false}
          disabled={disabled}
          slotProps={{
            textField: {
              placeholder,
            },
            desktopPaper: {
              sx: {
                // Customise dialog style
                boxShadow: 'rgba(0, 0, 0, 0.16) 0px 4px 8px;',
              },
            },
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    // Add a slight gap between the dialog and the input
                    offset: [0, 8],
                  },
                },
              ],
            },
          }}
          timezone={getUserTimezone()}
          value={value}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
          }}
          onChange={onChange}
        />
      </Container>
    </LocalizationProvider>
  );
};

const mapStateToProps = (state) => ({
  user: state.baseReducer.user,
});

export default connect(mapStateToProps, null)(TimePicker);
